import React from 'react';
import { Link } from 'react-router-dom';
import TrustBlocks from './TrustBlocks';
import FaqAccordion from './FaqAccordion';
import PageSEO from './PageSEO';

const ScreeningLanding = () => {
  return (
    <main className="App-main intent-landing">
      <PageSEO title="Screen Tenants Online | Credit Check + Identity Verification | Rentual" description="Full tenant screening with TransUnion credit report, Stripe identity verification, and AI-powered risk assessment. Results in minutes." path="/screening" />
      <section className="intent-hero">
        <p className="eyebrow-tag">Tenant Screening</p>
        <h1>Screen Ontario tenants in one clean flow.</h1>
        <p className="hero-subhead">
          Collect applications, verify info, and move straight into rent payments once approved.
        </p>
        <div className="hero-ctas">
          <Link className="primary-button" to="/register">Start free trial</Link>
          <Link className="ghost-button" to="/pricing">View pricing</Link>
        </div>
      </section>

      <section className="steps-section">
        <p className="eyebrow-tag">How it works</p>
        <h2>Review applicants without the chaos.</h2>
        <div className="steps-grid">
          <article className="step-card">
            <div className="step-number">1</div>
            <h3>Collect</h3>
            <p>Invite tenants to apply and submit documents in one place.</p>
          </article>
          <article className="step-card">
            <div className="step-number">2</div>
            <h3>Compare</h3>
            <p>See applicant status, notes, and screening info side-by-side.</p>
          </article>
          <article className="step-card">
            <div className="step-number">3</div>
            <h3>Decide &amp; collect rent</h3>
            <p>Approve the right tenant and enable rent payments in one flow.</p>
          </article>
        </div>
      </section>

      <section className="capabilities-section">
        <p className="eyebrow-tag">Key features</p>
        <h2>Everything you need for fast screening.</h2>
        <div className="capabilities-grid">
          <article className="capability-card">
            <div className="capability-icon">01</div>
            <h3>Application pipeline</h3>
            <p>Track every applicant stage at a glance.</p>
          </article>
          <article className="capability-card">
            <div className="capability-icon">02</div>
            <h3>Secure document vault</h3>
            <p>Store IDs, pay stubs, and leases securely.</p>
          </article>
          <article className="capability-card">
            <div className="capability-icon">03</div>
            <h3>Payments ready</h3>
            <p>Turn on rent payments the moment you approve a tenant.</p>
          </article>
        </div>
      </section>

      <TrustBlocks />

      <section className="pricing-preview">
        <p className="eyebrow-tag">Pricing</p>
        <h2>Simple plans for Ontario landlords.</h2>
        <div className="pricing-preview-grid">
          <div className="pricing-preview-card">
            <h3>Starter</h3>
            <p>Up to 5 units</p>
            <strong>$19/mo</strong>
          </div>
          <div className="pricing-preview-card">
            <h3>Growth</h3>
            <p>Up to 25 units</p>
            <strong>$59/mo</strong>
          </div>
          <div className="pricing-preview-card">
            <h3>Pro</h3>
            <p>Up to 100 units · Payments included</p>
            <strong>$149/mo</strong>
          </div>
        </div>
        <div className="hero-ctas">
          <Link className="ghost-button" to="/pricing">Compare plans</Link>
        </div>
      </section>

      <section className="faq-section">
        <p className="eyebrow-tag">FAQ</p>
        <h2>Questions about screening?</h2>
        <FaqAccordion items={[
          { question: 'Is Rentual built for Ontario landlords?', answer: 'Yes. Our workflows are designed around Ontario\'s RTA and LTB processes.' },
          { question: 'How fast can I start screening?', answer: 'Most landlords can publish a listing and invite applicants in minutes.' },
          { question: 'Are documents stored securely?', answer: 'Yes. Files are encrypted in transit and protected with role-based access.' }
        ]} />
      </section>

      <section className="cta-panel">
        <h3>Ready to screen and get paid?</h3>
        <p>Start your free trial and enable rent payments after approval.</p>
        <div className="hero-ctas">
          <Link className="primary-button" to="/register">Start free trial</Link>
          <Link className="ghost-button" to="/contact">Talk to us</Link>
        </div>
      </section>
    </main>
  );
};

export default ScreeningLanding;
